var _defs, _circle, _path, _line, _line2, _line3, _line4, _line5, _path2, _path3, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 5px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #62797e;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        fill: #ffe63f;\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        stroke-width: 4px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 39.1,
    cy: 37.4,
    r: 14.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.5,64.6h-5.4c-2.5,0-4.5,1-4.5-1.5v-4.9s-11.3-5.4-11.3-21.3,13.5-21.2,21.2-21.2,20.5,6.3,20.5,21.2-11.3,21.3-11.3,21.3v4.9c0,2.5-2,1.5-4.5,1.5h-4.7Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.1,
    y1: 3.9,
    x2: 39.1,
    y2: 7.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 66.6,
    y1: 38.3,
    x2: 70.4,
    y2: 38.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.8,
    y1: 38.3,
    x2: 11.7,
    y2: 38.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.1,
    y1: 14.3,
    x2: 18.8,
    y2: 17
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 58.5,
    y1: 17,
    x2: 61.3,
    y2: 14.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.1,62.4v-17s-1.8-9.5-6.2-5.5c-4.5,4.2,3.8,7.1,9.2,7.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.6,62.4v-17s1.8-9.5,6.2-5.5-3.8,7.1-9.2,7.1"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31,
    y1: 71,
    x2: 48.2,
    y2: 71
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.6eb9559227bd3d38a756c2a05354db47.svg";
export { ForwardRef as ReactComponent };